module.exports = __webpack_public_path__ + "static/media/view4.4a019172.jpg";